import React, { useContext, useEffect, useState } from 'react';
import {
   Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, ButtonGroup,
   Col, Collapse, Input, List, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter,
   ModalHeader, Row, Table
} from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { MdArrowRight, MdOutlineExpandLess, MdOutlineExpandMore } from "react-icons/md";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { DesktopContainer } from '../layouts';
import { api, constants, filterHelpers, storage, UserContext } from '../utils';

export default function CountScan(props) {
   const ICONS = {
      collapseIcon: <MdOutlineExpandLess className="mobileToggle align-self-center" />,
      expandIcon: <MdOutlineExpandMore className="mobileToggle align-self-center" />,
      arrowIcon: <MdArrowRight className="mobileToggleSmall align-self-center" />
   }
   const { id } = useParams();
   const { currentUser } = useContext(UserContext);
   const [addCase, setAddCase] = useState({});
   const [barcode, setBarcode] = useState(null);
   const [canEdit, setEdit] = useState(false);
   const [caseInProc, setCase] = useState({});
   const [data, setData] = useState({});
   const [expanded, setExpanded] = useState("0");
   const [initWgt, setInitWgt] = useState(true);
   const [isNoLabel, setNoLabel] = useState(false);
   const [loaded, setLoaded] = useState(false);
   const [manualEntry, setManual] = useState(null);
   const [needsWgt, setNeedsWgt] = useState(false);
   const [open, setOpen] = useState(null);
   const [showDetail, setShow] = useState(true);
   const [showWgt, setShowWgt] = useState(false);
   const [wgtDesc, setWgtDesc] = useState("");
   const sleep = ms => new Promise(r => setTimeout(r, ms));
   const navigate = useNavigate();
   let modalClassName = currentUser.theme ? `${currentUser.theme}` : "lightTheme";
   let savedDevice = JSON.parse(storage.getItem("deviceType"));
   const isMobile = savedDevice.isMobile;
   const hasScanner = savedDevice.hasScanner;

   const [types, setTypes] = useState([]);
   const NO_SUM = { value: 0, label: "No Summary" };
   const [filters, setFilters] = useState([
      { filterName: "typeId", value: NO_SUM }
   ]);

   useEffect(() => {
      if (addCase && needsWgt) {
         if (addCase.barcode > 0) {
            setNoLabel(false);
            setBarcode(null);
            setWgtDesc(caseInProc.wgtDesc);
         }
         else {
            setNoLabel(true);
         }

         setShowWgt(true);
         if (initWgt === true) {
            inputFocus("lblWgt");
            setInitWgt(false);
         }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [addCase])

   useEffect(() => {
      // if device has built-in scanner see if a scan was completed
      if (barcode && hasScanner && !manualEntry) {
         setLoaded(false);
         return;
      }
      if (manualEntry)
         inputFocus("manualInput");
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [barcode])

   useEffect(() => {
      if (!loaded && id) {
         api
            .post(`Mobile/GetCount/${id}`)
            .then(response => {
               if (response.data.success) {
                  setData(response.data.model);
                  setAddCase(response.data.addCase);
                  setEdit(response.data.canEdit);
                  const typeList = _.concat([NO_SUM],
                     _.map(response.data.viewTypes, v => ({ value: v.id, label: v.name })));
                  return { typeList: typeList };
               }
               else {
                  toast.error(response.data.message);
               }
            }).then(async ({ typeList }) => {
               setTypes(typeList);
            })
            .catch((error) => {
               api.catchHandler(error);
            })
            .finally(() => {
               setLoaded(true);
               inputFocus("searchInput");
            })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [id])

   useEffect(() => {
      if (!loaded && barcode) {
         // If a QR code was scanned then parse out just the barcode from the data
         var code = constants.GetRealBarcode(barcode);
         api
            .post(`Mobile/GetCountItem/${data.countId}/${code}/${data.countItem.inventoryType}`)
            .then(response => {
               if (response.data.success) {
                  setCase(response.data.model);
                  setNeedsWgt(true);
                  setInitWgt(true);

                  let theCase = Object.assign({}, addCase);
                  theCase["barcode"] = response.data.model.barcode;
                  theCase["caseType"] = response.data.model.caseDesc;
                  theCase["noLabelItem"] = response.data.model.itemNumber;
                  theCase["weight"] = response.data.model.weight;
                  theCase["whereCounted"] = "";
                  setAddCase(theCase);
               }
               else {
                  toast.error(response.data.message);
                  inputFocus("searchInput");
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
               inputFocus("searchInput");
            })
            .finally(() => {
               setLoaded(true);
            });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loaded])

   useEffect(() => {
      if (manualEntry) {
         inputFocus("manualInput");
         return;
      }

      if (!barcode) {
         inputFocus("searchInput");
         return;
      }

      setLoaded(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [manualEntry])

   function addCaseLabel() {
      if (addCase.barcode === 0 && addCase.whereCounted === "") {
         toast.error("You must supply information on where the no label item was counted");
         return;
      }

      setLoaded(false);
      api
         .post(`Mobile/AddCountCase/`, addCase)
         .then((response) => {
            if (response.data.success) {
               setData(response.data.model);
               clearCase("");
            } else {
               toast.error(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setLoaded(true);
            inputFocus("searchInput");
         });
   }

   function clearCase(itm) {
      setNeedsWgt(itm !== "");
      setWgtDesc("Net Weight / Item Qty");
      setInitWgt(true);
      setShowWgt(false);
      setNoLabel(false);
      setBarcode(null);

      let theCase = Object.assign({}, addCase);
      theCase["barcode"] = 0;
      theCase["caseType"] = "";
      theCase["noLabelItem"] = itm;
      theCase["weight"] = 0;
      theCase["whereCounted"] = "";
      setAddCase(theCase);
   }

   function close() {
      if (!canEdit) {
         navigate(constants.ENDPOINTS.countSearch);
         return;
      }

      confirmAlert({
         title: "Please Confirm",
         message: `You have not completed this inventory count! Do you wish to close this form? Click Cancel to return to the form or OK to continue closing.`,
         buttons: [
            {
               label: "OK",
               onClick: () => { navigate(constants.ENDPOINTS.countSearch); }
            },
            {
               label: "Cancel",
               onClick: () => { inputFocus("searchInput"); }
            },
         ],
      });
   }

   function deleteCase(caseId, desc) {
      confirmAlert({
         title: "Permanently Delete Case?",
         message: `This will permanently delete ${desc}. Are you sure?`,
         buttons: [
            {
               label: "Ok",
               onClick: () => {
                  setLoaded(false);
                  api
                     .post(`Mobile/DeleteCountCase/${data.countId}/${caseId}/${data.viewMode}`)
                     .then((response) => {
                        if (response.data.success) {
                           setData(response.data.model);
                           clearCase("");
                        } else {
                           toast.error(response.data.message);
                        }
                     })
                     .catch((error) => {
                        api.catchHandler(error);
                        toast.error(error);
                     })
                     .finally(() => {
                        setLoaded(true);
                        inputFocus("searchInput");
                     });
               },
            },
            {
               label: "Cancel",
               onClick: () => { inputFocus("searchInput"); }
            },
         ],
      });
   }

   const handleFocus = (event) => event.target.select();  // see PMCheck.js for a sample usage

   const handleKeypress = e => {
      // On key press for search input field
      if (e.charCode === 13 || e.key === 'Enter') {
         setManual(null);
         return;
      }
      inputFocus("manualInput");
   };

   async function inputFocus(fieldname) {
      await sleep(80);  // allows time for input to be recognized
      const el = document.querySelector(`input[name=${fieldname}]`);
      if (el !== null) {
         await el.focus();
      }
   }

   function lockCount() {
      if (!data.lineItems || data.lineItems.length < 1) {
         toast.error("You cannot lock an inventory count with no line items.");
         inputFocus("searchInput");
         return;
      }
      confirmAlert({
         title: "Lock Count",
         message: `Are you sure you want to lock this inventory count?`,
         buttons: [
            {
               label: "Yes",
               onClick: () => {
                  setLoaded(false);
                  api
                     .post(`Mobile/LockCount/${data.countId}`)
                     .then(response => {
                        if (response.data.success) {
                           toast.success("Count was locked");
                           navigate(constants.ENDPOINTS.countSearch);
                        }
                        else {
                           toast.error(response.data.message);
                        }
                     })
                     .catch((error) => {
                        api.catchHandler(error);
                     })
                     .finally(() => {
                        setLoaded(true);
                        inputFocus("searchInput");
                     })
               }
            },
            {
               label: "No",
               onClick: () => {
                  setBarcode(null);
                  inputFocus("searchInput");
               }
            },
         ],
      });
   }

   async function lookup(barcode) {
      // On change of search input field
      setBarcode(barcode);

      if (manualEntry) {
         inputFocus("manualInput");
         return;
      }
      inputFocus("searchInput");
   }

   function onCaseChange(field, value) {
      // Changes to the case in process
      let changes = Object.assign({}, addCase);
      changes[field] = value;
      setAddCase(changes);
   }

   function onTypeChange(newFilterValue) {
      const typ = _.find(types, x => x.value === newFilterValue.value);
      let newFilters = filterHelpers.getFilters(filters, ({ filterName: "typeId", value: typ }));
      setFilters(newFilters);

      let changes = Object.assign({}, data);
      changes["viewMode"] = newFilterValue.value;
      setData(changes);

      let thisCase = Object.assign({}, addCase);
      thisCase["viewMode"] = newFilterValue.value;
      setAddCase(thisCase);
   }

   const toggle = (idx) => {
      if (expanded === idx) {
         setExpanded();
      } else {
         setExpanded(idx);
      }

      if (canEdit) {
         inputFocus("searchInput");
      }
   };

   function toggleShow() {
      setShow(!showDetail);
      if (canEdit) {
         inputFocus("searchInput");
      }
   }

   return (
      <>
         <DesktopContainer screenName="Inventory Counts">
            <ServiceThreadSpinner on={!loaded}>
               {loaded && data && data.countId > 0 ?
                  <div>
                     {canEdit ?
                        <div>
                           <Row><Col className="h6 fw-bold" xs="12">Scan an inventory label to begin</Col></Row>
                           <Row><Col><hr className="mb-0 my-1" /></Col></Row>
                           <br />
                           {!hasScanner && isMobile ?
                              <div>
                                 <Row className="justify-content-center">
                                    <Col xs="12">
                                       <Button
                                          title="scan entry"
                                          className="shredButton w-100 btn-md"
                                          onClick={() => setOpen(1)}>
                                          Scan Barcode
                                       </Button>
                                    </Col>
                                 </Row>
                                 <Row className="lineheight8">&nbsp;</Row>
                              </div>
                              : null
                           }
                           <div>
                              <Row className="justify-content-center">
                                 <Col xs="12">
                                    <Button
                                       title="manual entry"
                                       className="shredButton w-100 btn-md"
                                       onClick={() => setManual(1)}>
                                       Manual Entry
                                    </Button>
                                 </Col>
                              </Row>
                              {isMobile ?
                                 <div>
                                    <Row className="lineheight8">&nbsp;</Row>
                                    <Row className="justify-content-center">
                                       <Col xs="12">
                                          <Input
                                             name="searchInput"
                                             placeholder="Focus here to scan barcode"
                                             className="h-100"
                                             onChange={(e) => lookup(e.target.value)}
                                          />
                                       </Col>
                                    </Row>
                                 </div>
                                 : null
                              }
                           </div>
                           <br />
                        </div>
                        : null
                     }

                     <Row className="align-items-center my-1">
                        <Col className="h5 fw-bold" xs={12}>
                           Display Mode:
                        </Col>
                     </Row>
                     <Row className="align-items-center my-1">
                        <Col xs={12}>
                           <FilterSelect
                              filterName="typeId"
                              options={types}
                              value={filterHelpers.getValue(filters, "typeId")}
                              onChangeCallback={e => onTypeChange(e)}
                           />
                        </Col>
                     </Row>
                     <Row className="lineheight8">&nbsp;</Row>

                     <Button color="primary" outline onClick={toggleShow} style={{ marginBottom: '1rem' }}>
                        Count: {data.displayId}
                     </Button>

                     <Collapse className="mx-0 py-0 px-0" isOpen={showDetail}>
                        {data.viewMode === 0 ?
                           <List type="unstyled">
                              <li className="mobileBlueBg text-white my-0 py-2 px-2">Case view hidden - Select a different display mode from above to load scanned cases</li>
                           </List>
                           : null
                        }

                        {data.viewMode === 1 && data.summaryItems ?
                           <div>
                              <ListGroup>
                                 {_.map(data.summaryItems, (sumItem, indexer) => {
                                    return (
                                       <ListGroupItem key={indexer} className={(indexer % 2 === 0) ? "mobileBlueBg text-white my-0 py-2 px-2" : "mobileBlueBgAlt text-white my-0 py-2 px-2"}>{sumItem.itemSummary}</ListGroupItem>
                                    )
                                 })}
                              </ListGroup>
                           </div>
                           : null
                        }

                        {data.viewMode === 2 && (!data.lineItems || data.lineItems.length < 1) ?
                           <List type="unstyled">
                              <li className="mobileBlueBg text-white my-0 py-2 px-2">No items have yet been scanned.</li>
                           </List>
                           : null
                        }

                        {data.viewMode === 2 && data.lineItems && data.lineItems.length > 0 ?
                           <div>
                              <Accordion open={expanded} toggle={toggle}>
                                 {_.map(data.lineItems, (item, index) => {
                                    return (
                                       <div details={item} key={index} >
                                          <AccordionItem className={(index % 2 === 0) ? "mobileBlueBg text-white my-0 py-1 px-1" : "mobileBlueBgAlt text-white my-0 py-1 px-1"}>
                                             <AccordionHeader targetId={index}>
                                                {item.itemDesc}
                                                {canEdit && data.countItem.inventoryType !== 2 ?  /* not locked and not an FG count*/
                                                   <div>
                                                      <Button children="Add for No Label"
                                                         className="btn btn-sm mx-1 px-1 py-0"
                                                         onClick={() => { clearCase(item.itemNumber); }} />
                                                   </div>
                                                   : null
                                                }
                                             </AccordionHeader>
                                             <AccordionBody accordionId={index} className="py-1 px-0">
                                                {item.cases && item.cases.length > 0 ?
                                                   <div>
                                                      {_.map(item.cases, (lot, idx) => {
                                                         return (
                                                            <div details={lot} key={idx} className="py-1 px-0">
                                                               {ICONS.arrowIcon} {lot.caseDesc}&nbsp;&nbsp;
                                                               {canEdit ?
                                                                  <Button children="Remove"
                                                                     className="btn btn-sm px-1 py-0"
                                                                     onClick={() => { deleteCase(lot.countCaseId, lot.caseDesc); }} />
                                                                  : null
                                                               }
                                                            </div>
                                                         )
                                                      })}
                                                   </div>
                                                   : null
                                                }
                                             </AccordionBody>
                                          </AccordionItem>
                                       </div>
                                    )
                                 })}
                              </Accordion>
                           </div>
                           : null
                        }
                     </Collapse>
                  </div>
                  : null
               }

               <Row className="lineheight8">&nbsp;</Row>
               {loaded && data && data.lineItems && canEdit && data.lineItems.length > 0 ?
                  <Row>
                     <Col xs="12">
                        <Button title="Save" className="shredButton w-100 btn-md my-0" onClick={() => lockCount()}>
                           Lock Count
                        </Button>
                     </Col>
                  </Row>
                  : null
               }
               <Row className="lineheight8">&nbsp;</Row>
               <Row>
                  <Col xs="12">
                     <Button title="To Search" className="btn w-100 btn-md my-0" onClick={() => close()}>
                        Close
                     </Button>
                  </Col>
               </Row>


               <Modal isOpen={open !== null} contentClassName={modalClassName}>
                  <ModalHeader children="Scan a Barcode" />
                  <ModalBody
                     children={
                        <BarcodeScannerComponent
                           height={350}
                           width={350}
                           onUpdate={(err, result) => {
                              if (result) {
                                 setBarcode(result.text);
                                 setOpen(null);
                                 setLoaded(false);
                                 inputFocus("searchInput");
                              }
                              else {
                                 setBarcode(null);
                              }
                           }}
                           // onError={(err) => console.error("error", err)}
                           facingMode={"environment"}
                        />
                     }
                  />
                  <ModalFooter>
                     <Button
                        className="shredButton ms-7"
                        onClick={() => {
                           setOpen(null);
                           inputFocus("searchInput");
                        }}>Cancel
                     </Button>
                  </ModalFooter>
               </Modal>


               <Modal isOpen={manualEntry !== null} contentClassName={modalClassName}>
                  <ModalHeader children="Enter Barcode" />
                  <ModalBody
                     children={
                        <Input
                           name="manualInput"
                           placeholder="Enter barcode"
                           className="h-100"
                           onChange={(e) => lookup(e.target.value)}
                           onKeyPress={handleKeypress}
                        />
                     }
                  />
                  <ModalFooter>
                     <ButtonGroup>
                        <Button children="Retrieve"
                           className="button-success"
                           onClick={() => { setManual(null); }} />
                        <Button children="Cancel"
                           className="button-danger"
                           onClick={() => {
                              setBarcode(null);
                              setManual(null);
                           }} />
                     </ButtonGroup>
                  </ModalFooter>
               </Modal>


               {loaded && addCase ?
                  <Modal isOpen={showWgt !== false} contentClassName={modalClassName}>
                     <ModalHeader className="mobileBlueBg text-white" children="Inventory Quantity" />
                     <ModalBody className="mobileBlueBgAlt text-white"
                        children={
                           <Table borderless size="sm">
                              <tbody>
                                 <tr>
                                    <td className="data-cell my-0 py-0">
                                       <label className="h6 text-white fw-bold my-0">{addCase.noLabelItem}</label>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td className="data-cell m-0 p-0 lineheight8">&nbsp;</td>
                                 </tr>
                                 <tr>
                                    <td className="data-cell my-0 py-0">
                                       <label className="text-white h6 fw-bold my-1">{wgtDesc}</label>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td className="data-cell my-0 py-0">
                                       <Input
                                          name="lblWgt"
                                          type="number"
                                          value={addCase.weight}
                                          className="h-100"
                                          onFocus={handleFocus}
                                          onChange={(e) => { onCaseChange("weight", e.target.value) }}
                                          placeholder="Enter amount ..."
                                       />
                                    </td>
                                 </tr>
                                 <tr>
                                    <td className="data-cell m-0 p-0 lineheight8">&nbsp;</td>
                                 </tr>
                                 {isNoLabel ?
                                    <tr>
                                       <td className="data-cell my-0 py-0">
                                          <label className="h6 text-white fw-bold my-1">Where Counted</label>
                                       </td>
                                    </tr>
                                    : null
                                 }
                                 {isNoLabel ?
                                    <tr>
                                       <td className="data-cell my-0 py-0">
                                          <Input
                                             name="lblWhere"
                                             type="text"
                                             value={addCase.whereCounted}
                                             className="h-100"
                                             onChange={(e) => { onCaseChange("whereCounted", e.target.value) }}
                                             placeholder="Enter machine, area, etc ..."
                                          />
                                       </td>
                                    </tr>
                                    : null
                                 }
                                 <tr>
                                    <td className="data-cell m-0 p-0 lineheight15">&nbsp;</td>
                                 </tr>
                                 <tr>
                                    <td className="data-cell my-0 mx-0 p-0">
                                       <Button className="shredButton w-100 btn-md my-0" onClick={() => { addCaseLabel(); }}>
                                          OK
                                       </Button>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td className="data-cell my-0 mx-0 p-0">
                                       <Button className="btn w-100 btn-md mt-2 mb-0" onClick={() => { clearCase(""); }}>
                                          Cancel
                                       </Button>
                                    </td>
                                 </tr>
                              </tbody>
                           </Table>
                        }
                     />
                  </Modal>
                  : null
               }

            </ServiceThreadSpinner>
         </DesktopContainer >
      </>
   );
}
